<ng-container>
  @if (isReady()) {
    <front-menu
      [serviceCategories]="serviceCategories()"
      [solutionCategories]="solutionCategories()"
    />

    <router-outlet />

    <front-footer
      [serviceCategories]="serviceCategories()"
      [solutionCategories]="solutionCategories()"
    />
    <go-top />
  }
</ng-container>
